//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SocialVideoFrameComponent",
  components: {
    RutubeVideo: () => import("@/components/common/RutubeVideo"),
    YoutubeVideo: () => import("@/components/common/YoutubeVideo")
  },
  props: {
    youtube: {
      type: [String, null],
      default: () => null
    },
    rutube: {
      type: [String, null],
      default: () => null
    },
  },
}
